// extracted by mini-css-extract-plugin
export default {"container":"stat-item_container__3lckH"};